import { hasAnyRole } from '../../utils/roles';
import { ROLES } from '../../utils/roles';

const { ROLE_OWNER, ROLE_ADMINISTRATOR } = ROLES;

const ALLOWED_ROLES_MANAGE_USERS = [ROLE_OWNER, ROLE_ADMINISTRATOR];

export function canManageUsers(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_MANAGE_USERS);
}
